export const CREATE_GROUP = 'CREATE_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const SET_GROUPS = 'SET_GROUPS';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const UPDATE_GROUP_ADMIN_ACCESS = 'UPDATE_GROUP_ADMIN_ACCESS';

export const FETCH_COHORT_GROUPS_LISTING_DATA_START =
  'FETCH_COHORT_GROUPS_LISTING_DATA_START';
export const FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS =
  'FETCH_COHORT_GROUPS_LISTING_DATA_SUCCESS';
export const FETCH_COHORT_GROUPS_LISTING_DATA_FAILURE =
  'FETCH_COHORT_GROUPS_LISTING_DATA_FAILURE';
